import { CapoPlugin } from "/opt/build/repo/node_modules/.pnpm/@unhead+vue@1.9.14_vue@3.4.30/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];